var render, staticRenderFns
import script from "./benefit_list.vue?vue&type=script&lang=js"
export * from "./benefit_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec272e68')) {
      api.createRecord('ec272e68', component.options)
    } else {
      api.reload('ec272e68', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/treety/treeties/detail/benefit_list.vue"
export default component.exports